import React from "react";
import { useNavigate } from "react-router-dom";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useI18n } from "../i18n";
import { LANGS, pathFor, rememberLang } from "../config/site";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function LanguageSwitcher({ pageKey }) {
  const { lang, d } = useI18n();
  const navigate = useNavigate();

  const change = (code) => {
    rememberLang(code);
    if (code !== lang) navigate(pathFor(code, pageKey));
  };

  const current = LANGS.find((l) => l.code === lang);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          aria-label={d.ui.selectLanguage}
          className="focus-gold inline-flex items-center gap-2 rounded-full border border-jlo-gold/30 px-3 py-1.5 text-sm text-jlo-warm/90 hover:border-jlo-gold/70 hover:text-jlo-gold transition-colors"
        >
          <Globe className="h-4 w-4 text-jlo-gold" aria-hidden="true" />
          <span className="hidden sm:inline">{current?.native}</span>
          <span className="sm:hidden uppercase">{lang}</span>
          <ChevronDown className="h-3.5 w-3.5 opacity-70" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-jlo-bg2 border-jlo-gold/20 text-jlo-warm max-h-[70vh] overflow-y-auto"
      >
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => change(l.code)}
            className="cursor-pointer focus:bg-jlo-gold/15 focus:text-jlo-gold gap-2"
          >
            <span className="w-4">{l.code === lang && <Check className="h-3.5 w-3.5 text-jlo-gold" />}</span>
            <span className="flex-1">{l.native}</span>
            <span className="text-xs text-jlo-gray uppercase">{l.code}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
